<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <p-password
    [id]="id()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [toggleMask]="true"
    [feedback]="false"
    (input)="updateValue($any($event.target).value)"
    (blur)="markAsTouched()" />
</ui-control-field>
